
import Vue from "vue";
import { Period } from ".";
import { diff, sub } from "./@types";
import DayLine from "./DayLine.vue";

export default Vue.extend({
  components: {
    DayLine,
  },
  props: {
    value: Object as () => Period,
    readonly: Boolean,
  },
  data() {
    return {
      from: "",
      to: "",
      b: undefined as string | undefined,
      includesBreak: false,
      showError: false,
    };
  },
  inject: {
    form: { default: null },
  },
  computed: {
    shouldValidate(): boolean {
      return true;
    },
    hasError(): boolean {
      return true;
    },

    duration(): any {
      return sub(diff(this.from, this.to), this.b || "0:00").split(":");
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.includesBreak = this.value.breakTime !== null;
        this.from = this.value.from;
        this.to = this.value.to;
        this.b = this.value.breakTime;
      },
    },
  },
  methods: {
    validate(force?: boolean, value?: any): boolean {
      if (force) {
        this.showError = this.hasError;
      }
      return this.hasError;
    },
    reset() {
      this.$emit("input", { from: "00:00", to: "00:00", breakTime: null });
      this.resetValidation();
    },
    resetValidation() {
      this.showError = false;
    },
    onInput(): void {
      if (!(this.$refs.from as any).hasError && !(this.$refs.to as any).hasError) {
        const err = this.showError;
        this.resetValidation();
        this.$emit("input", { from: this.from, to: this.to, breakTime: !this.includesBreak ? null : this.b || "00:00" });
        if (err) {
          this.$nextTick(() => this.validate(true));
        }
      }
    },
  },
  created() {
    const frm = (this as any).form;
    frm && frm.register(this);
  },
  beforeDestroy() {
    const frm = (this as any).form;
    frm && frm.unregister(this);
  },
});
